import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {View, ScrollView} from 'react-native';

////////////////////
//////////// utils
import {getDataAtPath} from 'src/Utils/fireUtils';
import isIphoneX from 'src/Utils/IphoneXHelper';
const isX = isIphoneX();

//////////////////////
///////// components
import {TopTab, TopTabButton} from 'src/Modules/TabViews';

import ScavengerHuntInfoAbout from 'src/Registration/ScavengerHuntInfoAbout';
import HuntLeaderboard from 'src/Registration/HuntLeaderboard';

import ModalOmniBar from 'src/Modules/OmniBars/ModalOmniBar';
import CallSupportLine from 'src/HeaderComponents/CallSupportLine';
import {navigationRef} from 'src/Nav/navigationHelpers';
import {useUserId} from 'src/Hooks/reduxHooks';
import {analytics} from 'src/Utils/db';
import {useUserTicketCount} from '../Hooks/reduxHooks';
import {askToCreateTeam, createHunt} from '../Utils/huntFunctions';
import {useExplorerPass} from '../Utils/explorerPassHelper';

const foxIconWhite = require('src/Images/Icons/foxIconWhite.png');

const ScavengerHuntInfoModal = () => {
  const currentHunt = useSelector((state) => state.hunts.currentHunt);
  // Alert.alert('currentHunt', JSON.stringify(currentHunt));
  const barHunt = currentHunt?.hunt_type?.includes('bar');

  const [leaderboard, setLeaderboard] = useState(null);
  const [view, setView] = useState('about');
  const playTestState = useSelector((state) => state.app_info?.playTestState);
  const userId = useUserId();

  const getGroupLeaderboard = async () => {
    const huntId = currentHunt.hunt_id;
    if (huntId && !barHunt) {
      const path = `scavengerhunt/leaderboard/${huntId}/top10`;
      const leaderboard = await getDataAtPath(path);

      const formatLeaderboard =
        (leaderboard &&
          leaderboard?.filter?.((group) => {
            return group.score > 0;
          })) ||
        false;

      if (formatLeaderboard?.length >= 2) {
        setLeaderboard(formatLeaderboard);
      }
    }
  };

  useEffect(() => {
    try {
      getGroupLeaderboard();
      analytics().logViewItem({
        items: [
          {
            item_brand: 'scavenger_hunt',
            item_name: currentHunt?.name,
          },
        ],
      });
    } catch (error) {
      console.log({error});
    }
  }, [currentHunt]);

  const userTicketCount = useUserTicketCount();
  const hasExplorerPass = !!useExplorerPass();
  console.log({userTicketCount});

  const handleStartPress = () => {
    // prompt to log in if not logged in
    if (!userId) {
      return navigationRef.navigate('LoginModal', {
        message: 'You must log in to start a scavenger hunt',
      });
    }

    if (playTestState) {
      console.log('creating hunt in playtest');
      return createHunt(currentHunt, 'Standard', true);
    }

    if (!userTicketCount && !hasExplorerPass) {
      return navigationRef.navigate('PurchaseModal', {
        handleDone: () => {
          askToCreateTeam(currentHunt);
        },
        successMessage:
          'Success, your tickets have been added to your account. You can now create a group.',
      });
    }

    askToCreateTeam(currentHunt);
  };

  const handleJoinPress = () => {
    return userId
      ? navigationRef.navigate('JoinHuntModal')
      : navigationRef.navigate('LoginModal', {
          navigateOnCloseRoute: 'JoinHuntModal',
          message: 'You must log in to start a scavenger hunt',
        });
  };

  return (
    <View
      style={{
        flex: 1,
        backgroundColor: 'white',
        alignItems: 'center',
        justifyContent: 'flex-start',
      }}>
      <CallSupportLine />
      {!barHunt && (
        <TopTab>
          <TopTabButton
            text={'About This Hunt'}
            handlePress={() => setView('about')}
            active={view === 'about'}
          />
          {playTestState == false && (
            <TopTabButton
              text={'FAQ'}
              handlePress={() => {
                setView('about');
                navigationRef.navigate('FAQ');
              }}
              active={false}
            />
          )}
          {leaderboard?.length >= 2 && (
            <TopTabButton
              text={'Leaderboard'}
              handlePress={() => setView('leaderboard')}
              active={view === 'leaderboard'}
            />
          )}
        </TopTab>
      )}

      <ScrollView
        style={{
          flex: 1,
          paddingTop: 5,
          backgroundColor: global?.color?.white1,
        }}>
        {view === 'about' && (
          <ScavengerHuntInfoAbout handleStartPress={handleStartPress} />
        )}
        {view === 'leaderboard' && (
          <HuntLeaderboard hunt={currentHunt} leaderboard={leaderboard} />
        )}
        <View style={{height: 120}} />
      </ScrollView>
      <ModalOmniBar
        left={{
          icon: 'arrow-left-circle',
          handlePress: () => {
            navigationRef.navigate(
              'LandingPageMain',
              {},
              'ScavnegerHuntInfoModal',
            );
          },
          text: 'Go Back',
        }}
        omniButton={{
          icon: foxIconWhite,
          imageIcon: true,
          //icon: 'check',
          iconLibrary: 'FontAwesome',
          color: global?.color?.orange,
          handlePress: handleStartPress,
          text: 'Start Pre-Registration',
        }}
        right={{
          icon: 'people',
          handlePress: handleJoinPress,
          text: 'Join Friends Group',
        }}
        containerStyle={{
          position: 'absolute',
          left: 0,
          right: 0,
          bottom: 0,
          marginBottom: isX ? 20 : 0,
        }}
      />
    </View>
  );
};

export default ScavengerHuntInfoModal;
